import MediaGrid from "./MediaGrid";

const SharePreview = ({ data }) => {
    const getAvatarSrc = (pic) => (!pic ? "/default-avatar.png" : pic.startsWith("http") ? pic : "/upload/" + pic);

    return (
        <div className="postPreview">
            <div className="previewHeader">
                <img 
                    src={getAvatarSrc(data.profilePic)} 
                    alt="" 
                    className="avatar"
                />
                
                <div className="info">
                    <span className="name">
                        {data.name}
                    </span>

                    <span className="timestamp">
                        Original Post
                    </span>
                </div>
            </div>

            <div className="previewContent">
                {data.desc && (
                    <p className="desc">
                        {data.desc.substring(0, 150)}{data.desc.length > 150 && "..."}
                    </p>
                )}
                
                <MediaGrid rawData={data.img} />
            </div>
        </div>
    );
};

export default SharePreview;